module.exports = __webpack_public_path__ + "images/emoji/earth_asia.6de30653aeec10c3659e.png";